import React, { Component } from 'react';
import { connect } from 'react-redux';
import { history } from '../helpers/history';
import { alertActions, userActions } from '../actions';
import App from '../components/App';

class AppContainer extends Component {
  constructor(props) {
    super(props);
    const { dispatch } = props;

    history.listen((location, action) => {
      // clear alert on location change
      document.body.className = location.pathname.replace(/\//g, '-').slice(1)
      dispatch(alertActions.clear());
    });
  }

  render() {
    const { store, alertMessage, currentUser, userLoading, loadUserFromToken } = this.props;

    return (
      <App store={store} history={history} currentUser={currentUser} userLoading={userLoading} loadUserFromToken={loadUserFromToken} alertMessage={alertMessage}/>
    );
  }
  
}

function mapStateToProps(state) {
  const { message, type } = state.alerts;
  const { currentUser, loading } = state.users;
  return {
    alertMessage: message,
    alertType: type,
    currentUser: currentUser,
    userLoading: loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadUserFromToken: () => { dispatch(userActions.meFromToken()) },
    dispatch
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(AppContainer)
